/* ============================================================
   AWERI UTIL - tiny site-wide helpers that live in ONE place,
   shared by the inline section scripts (header search, PDP
   pincode) and the app assets (cart). Loaded FIRST (defer) in
   layout/theme.liquid, before every other aweri-* script, so
   window.AweriEscapeHtml exists by the time any consumer runs.
   Each consumer calls this at runtime, with a tiny inline
   fallback for the rare case this asset fails to load, so the
   escaping logic has a single source of truth here.
   Keep this file dependency-free and minimal.
   ============================================================ */
(function () {
  'use strict';
  // HTML-escape for safe interpolation into innerHTML. Replaces the former
  // duplicates esc() (aweri-header), escapeHtml() (aweri-cart), pinEsc()
  // (aweri-product) - all the same 4-character escape.
  window.AweriEscapeHtml = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  };
})();
